
import { Component, Prop, Vue } from "vue-property-decorator";
import { SingleChargePickerModel } from "./SingleChargePickerModel";
import { initialChargeModel } from "./EditorTool";
import SingleChargePicker from "./SingleChargePicker.vue";

@Component({
  components: {
    SingleChargePicker,
  },
})
export default class MultiChargePicker extends Vue {
  @Prop() value!: { id: number; model: SingleChargePickerModel }[];

  currentIndex = 0;

  private nextId(): number {
    return this.currentIndex++;
  }

  async add(): Promise<void> {
    const newCharge = {
      id: this.nextId(),
      model: await initialChargeModel(),
    };
    this.value.push(newCharge);
    this.update();
  }

  remove(idToRemove: number): void {
    let index = 0;
    while (index < this.value.length) {
      if (this.value[index].id == idToRemove) {
        this.value.splice(index, 1);
        this.update();
        return;
      } else {
        ++index;
      }
    }
  }

  update(): void {
    this.$emit("input", this.value);
  }
}
